export default __webpack_public_path__ + "static/media/p5.08c1cc10.jpg";